import { render, staticRenderFns } from "./tagInfo.vue?vue&type=template&id=42a80b57"
import script from "./tagInfo.vue?vue&type=script&lang=js"
export * from "./tagInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports